import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TranslateModule } from '@ngx-translate/core';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ProjectValuationNavigationComponent } from './project-valuation/project-valuation-navigation/project-valuation-navigation.component';
import { TopMainNavigationComponent } from './top-main-navigation/top-main-navigation.component';
import { SideBarNavigationComponent } from './side-bar-navigation/side-bar-navigation.component';
import { ProjectNavigationComponent } from './project-valuation/project-navigation/project-navigation.component';
import { ValuationPortofolioNavigationComponent } from './project-valuation/valuation-portofolio-navigation/valuation-portofolio-navigation.component';
import { DashboardNavigationComponent } from './project-valuation/dashboard-navigation/dashboard-navigation.component';
import { PropertiesNavigationComponent } from './project-valuation/properties-navigation/properties-navigation.component';
import { ComparablesNavigationComponent } from './comparables/comparables-navigation/comparables-navigation.component';
import { ComparablesActionsNavigationComponent } from './comparables/comparables-actions-navigation/comparables-actions-navigation.component';
import { AdminNavigationComponent } from './admin/admin-navigation/admin-navigation.component';
import { RolesManagementNavigationComponent } from './admin/roles-management-navigation/roles-management-navigation.component';
import { TenantNavigationComponent } from './project-valuation/tenant-navigation/tenant-navigation.component';
import { ProjectMainNavigationComponent } from './project-main/project-main-navigation/project-main-navigation.component';
import { ProjectstdNavigationComponent } from './project-main/projectstd-navigation/projectstd-navigation.component';
import { ValuationPortfolioMainComponent } from './project-main/valuation-portfolio-main/valuation-portfolio-main.component';
import { CalculationModelNavigationComponent } from './admin/calculation-model-navigation/calculation-model-navigation.component';
import { RaciCounterCardComponent } from '../modules/raci/components/raci-counter-card/raci-counter-card.component';
import { DataverseActionsNavigationV2Component } from './dataverse/dataverse-actions-navigation-v2/dataverse-actions-navigation-v2.component';
import { RaciTemplateNavigationComponent } from './admin/raci-template-navigation/raci-template-navigation.component';
import { RaciNavigationComponent } from './raci-navigation/raci-navigation.component';
import { UserDashboardNavigationComponent } from './user-dashboard/user-dashboard-navigation.component';
import { RecurrentValuationsPortfolioSelectionSidebarComponent } from './project-main/recurrent-valuations-portfolio-selection-sidebar/recurrent-valuations-portfolio-selection-sidebar.component';
import { AppCommonModule } from '../components/common/app-common.module';
import { MenusModule } from '@progress/kendo-angular-menu';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { PopupModule } from '@progress/kendo-angular-popup';
import { EditorModule } from '@progress/kendo-angular-editor';
import { RouterModule } from '@angular/router';
import { LocalizationNavigationComponent } from './admin/localization-navigation/localization-navigation.component';
import { ProjectValuationCounterCardComponent } from './project-valuation/project-valuation-counter-card/project-valuation-counter-card.component';

/**
 * Navigation module
 */
@NgModule({
    imports: [
        EditorModule,
        MenusModule,
        DateInputsModule,
        ChartsModule,
        ExcelExportModule,
        CommonModule,
        GridModule,
        DropDownsModule,
        ReactiveFormsModule,
        ButtonsModule,
        TranslateModule,
        UploadsModule,
        FormsModule,
        LayoutModule,
        InputsModule,
        PopupModule,
        RouterModule.forChild([]),
        AppCommonModule
    ],
    declarations: [
        ProjectValuationNavigationComponent,
        TopMainNavigationComponent,
        ProjectValuationCounterCardComponent,
        SideBarNavigationComponent,
        ProjectNavigationComponent,
        ValuationPortofolioNavigationComponent,
        DashboardNavigationComponent,
        PropertiesNavigationComponent,
        ComparablesNavigationComponent,
        ComparablesActionsNavigationComponent,
        AdminNavigationComponent,
        RolesManagementNavigationComponent,
        TenantNavigationComponent,
        ProjectMainNavigationComponent,
        ProjectstdNavigationComponent,
        ValuationPortfolioMainComponent,
        CalculationModelNavigationComponent,
        RaciCounterCardComponent,
        RaciTemplateNavigationComponent,
        RaciNavigationComponent,
        UserDashboardNavigationComponent,
        DataverseActionsNavigationV2Component,
        RecurrentValuationsPortfolioSelectionSidebarComponent,
        LocalizationNavigationComponent
    ],
    exports: [
        ProjectValuationNavigationComponent,
        TopMainNavigationComponent,
        ProjectValuationCounterCardComponent,
        SideBarNavigationComponent,
        ProjectNavigationComponent,
        ValuationPortofolioNavigationComponent,
        DashboardNavigationComponent,
        PropertiesNavigationComponent,
        ComparablesNavigationComponent,
        ComparablesActionsNavigationComponent,
        AdminNavigationComponent,
        RolesManagementNavigationComponent,
        TenantNavigationComponent,
        ProjectMainNavigationComponent,
        ProjectstdNavigationComponent,
        ValuationPortfolioMainComponent,
        CalculationModelNavigationComponent,
        RaciCounterCardComponent,
        RaciTemplateNavigationComponent,
        RaciNavigationComponent,
        UserDashboardNavigationComponent,
        DataverseActionsNavigationV2Component,
        RecurrentValuationsPortfolioSelectionSidebarComponent
    ]
})
export class NavigationModule { }
